import { render, staticRenderFns } from "./le_tp_aside.vue?vue&type=template&id=3149164a&scoped=true&"
import script from "./le_tp_aside.vue?vue&type=script&lang=js&"
export * from "./le_tp_aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149164a",
  null
  
)

export default component.exports